///<reference path="./smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="collection-model.ts"/>
///<reference path="collection-base.ts"/>


module Meevo.Components.Controls.SmartMover {
    import Dictionary = _.Dictionary;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export abstract class SmartMoverApiCollection<T> extends SmartMoverCollectionBase<T> implements IApiCollection<T> {
        protected readonly criteria: Dictionary<any>;
        protected sortBy?: string;

        public childCollection?: IApiCollection<any>;
        public parentCollection?: IApiCollection<any>;

        private canceller: ng.IDeferred<any> = null;

        protected get url(): string {
            return this.options.url;
        }

        constructor(connectedModel: ModelValueType[], items: T[] = [], options: ICollectionOptions<T> = {} as ICollectionOptions<T>) {
            super(connectedModel, items, options);

            this.criteria = angular.extend({
                businessTypeList: null,
                locationList: null,
                hierarchyId: null,
                branchId: null,
                objectStateEnumList: [ObjectStateEnum.Active],
                displayName: null,
                fieldOrderBy: 'DisplayName',
                orderAscDesc: 'Ascending'
            }, options.criteria || {});
            this.updateCriteria(options.criteria);
        }

        protected criteriaIsValid(): boolean {
            return true;
        }

        public fetch(dataService: Meevo.Components.BaseClasses.IDataService = this.dataService): ng.IPromise<any> {
            this.dataService = dataService;

            if (!this.criteriaIsValid()) {
                return dataService.Promise.resolve([]);
            }

            if (this.canceller) {
                this.canceller.resolve([]);
            }


            this.emit(ON_FETCH_START);
            this.canceller = dataService.Promise.defer();

            return dataService
                .getListPaged<T, any>(this.url, {criteria: this.criteria, itemsPerPage: 50000, sortBy: this.sortBy}, null, null, {
                    timeout: this.canceller.promise
                })
                .then((items = []) => this.handleResponse(items))
                .then(() => {
                    this.emit('sync', this.allModelsList, this.dataService);

                    if (this.childCollection) {
                        return this.childCollection.fetch(dataService);
                    } else {
                        this.emit('all-collection-fetched');
                    }
                });
        }

        public updateCriteria(criteria?: Dictionary<any>): void {
            if (!criteria) return;

            angular.extend(this.criteria, criteria);
        }

        public getCriteria() {
            return this.criteria;
        }
    }
}
